// @flow
import React from 'react';
import { sendMessage } from '../../../chat/actions.any';

import Config from '../../config';
import { dispatch, getStore } from '../../Utils';
import { setChatRecordingFiles, setChatRecordingFilesVisible } from '../../redux/tool-webjam/actions';
import { FEATURE_CUSTOM_REDUX } from '../../constant';
import Linkify from '../../../base/react/components/web/Linkify';
import { setChatSenderLanguage } from './reducer/actions';
import { ct } from '../../constant-Utils';
import { setDownloadTitle } from '../../redux/tool-webjam-v3/actions';
const { socket_endpoint } = Config;
declare var APP: Object;


export const parseInComingMessage = (content) => {

    //const imageBase = "https://live.realtimeaudio.com";
    const imageBase = `${socket_endpoint}`;


    const downloadFile = (e, files, type = '') => {
        dispatch(setDownloadTitle(ct("rta-trmc.chat.downloadFiles")));
        let { chatFiles, chatFilesVisible } = getStore(FEATURE_CUSTOM_REDUX);
        if (chatFiles) {
            files = chatFiles.concat(files)
        }


        e.preventDefault();
        dispatch(setChatRecordingFiles(files));

        if (!chatFilesVisible) {
            dispatch(setChatRecordingFilesVisible(true));
        }
    }

    let processedMessage = [];
    content.forEach(i => {
        if (typeof i === 'string') {
            if (i.indexOf('file-TRMC') !== -1) {
                const fileName = i.split('-');

                if (i.match(/.(jpg|jpeg|png|gif)$/i)) {
                    // if image
                    processedMessage.push(
                        <div key={i + Math.random()} className="img-file-downloadable">
                            <div className="img-message-label">
                                <img className="img-chat" src={imageBase + `/static/chatFiles/${fileName[fileName.length - 1]}`} alt={fileName[2]} />
                            </div>
                            <div className="img-download-lnk">
                                <a
                                    // href={imageBase + `/static/chatFiles/${fileName[fileName.length - 1]}`}
                                    href='#'
                                    target="_blank" rel="noopener noreferrer"
                                    className='second'

                                    download
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        downloadFile(e, [{
                                            name: fileName[fileName.length - 1],
                                            file: imageBase + '/static/chatFiles/' + fileName[fileName.length - 1],
                                            filename: fileName[fileName.length - 1],
                                            time: new Date().getTime()
                                        }], 1)
                                    }}
                                >
                                    {ct("rta-trmc.dashboard.myRecording.download")}
                                </a>
                            </div>
                        </div>
                    );
                } else {
                    // unknown file format
                    processedMessage.push(
                        <div key={i + Math.random()} className="file-downloadable">
                            <div className="message-label"><Linkify key={i + "a"}>{fileName[2]}</Linkify></div>
                            <div className="download-lnk">
                                <a
                                    // href={imageBase + `/static/chatFiles/${fileName[fileName.length - 1]}`}
                                    href='#'
                                    // target="_blank"
                                    // rel="noopener noreferrer"
                                    className='first'
                                    download
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        downloadFile(e, [{
                                            name: fileName[fileName.length - 1],
                                            file: imageBase + '/static/chatFiles/' + fileName[fileName.length - 1],
                                            filename: fileName[fileName.length - 1],
                                            time: new Date().getTime()

                                        }], 2)
                                    }
                                    }
                                >
                                    {ct("rta-trmc.dashboard.myRecording.download")}
                                </a>
                            </div>
                        </div>
                    );
                }
            } else {
                processedMessage.push(<Linkify key={i + "-" + Math.random()}>{i}</Linkify>);
            }
        } else {
            processedMessage.push(i);
        }
    });
    return processedMessage;
}

export const handleInput = (message, isFile) => {
    let { lang, langForm, chatTranslatorStatus, chatLanguageGender } = APP.store.getState()["features/customise/app/chat"];

    if (isFile) {
        APP.store.dispatch(sendMessage(message))
    } else {
        let _langForm = "";

        if (chatTranslatorStatus) {
            if (lang) {

                if (langForm != "") {
                    _langForm = langForm;
                } else if (chatLanguageGender[lang] != undefined) {
                    if (chatLanguageGender[lang][0]) {
                        _langForm = chatLanguageGender[lang][0];
                    }
                }
            }
        }

        APP.store.dispatch(sendMessage(message + '/TRMC-LANG-CHANGE/' + JSON.stringify({
            senderLang: chatTranslatorStatus ? lang : "",
            senderGender: _langForm
        })))
    }
}

export const filterMessages = async (message, id = "") => {
    let selectedLang = APP.store.getState()["features/customise/app/chat"].lang;
    let newMessage = '';
    if (typeof message == "string") {
        // getting the from langauge passed with //
        var fromLang = message.split("/TRMC-LANG-CHANGE/");

        newMessage = fromLang[0];

        try {
            // if (!fromLang[1]) {
            //     // for mobile phones use default language
            //     fromLang.push('en');
            // }

            console.log("message details ", fromLang, selectedLang)

            let messageDetail = {};
            if (fromLang[1] != undefined) {
                let messageDetail = JSON.parse(fromLang[1])
                if (messageDetail.hasOwnProperty("senderGender")) {
                    dispatch(setChatSenderLanguage(messageDetail.senderGender))
                }
            }

            if (message.indexOf('file-TRMC') !== -1) {
                newMessage = message;
            } else if (messageDetail?.senderLang === selectedLang) {
                newMessage = fromLang[0];
            } else {

                if (selectedLang) {

                    if (selectedLang.includes("-")) {
                        selectedLang = selectedLang.split("-")[0]
                    }

                    const rawResponse = await fetch(encodeURI(`https://www.googleapis.com/language/translate/v2?key=AIzaSyAgWRE_YstOzCdkPCe-E8H5mlzUEFeXKe0&target=${selectedLang}&q=${fromLang[0]}`), {
                        method: 'GET',
                    });

                    const content = await rawResponse.json();
                    if (content.data && content.data.translations && content.data.translations[0].translatedText) {
                        newMessage = content.data.translations[0].translatedText;
                    }
                }
            }
        }
        catch (e) {
            console.log("chat translate api ", e)
        }
    }
    return newMessage;
}


const retrieveImageFromClipboardAsBlob = (pasteEvent, callback) => {
    if (pasteEvent.clipboardData == false) {
        if (typeof (callback) == "function") {
            callback(undefined);
        }
    };

    var items = pasteEvent.clipboardData.items;

    if (items == undefined) {
        if (typeof (callback) == "function") {
            callback(undefined);
        }
    };

    for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i].getAsFile();

        if (typeof (callback) == "function") {
            callback(blob);
        }
    }
}

export const handleChatPaste = (e, uploadRef) => {
    retrieveImageFromClipboardAsBlob(e, (imageBlob) => {
        // uploading the image blob
        uploadRef.current.fileSubmit({ target: { files: [imageBlob] } });
    });
}

export const handleChatDrop = (e, uploadRef) => {
    e.preventDefault();
    var data = e.dataTransfer,
        files = data.files;
    uploadRef.current.fileSubmit({ target: { files: files } });
}

